import { render, staticRenderFns } from "./CongestionOld.vue?vue&type=template&id=14836154&scoped=true&"
import script from "./CongestionOld.vue?vue&type=script&lang=js&"
export * from "./CongestionOld.vue?vue&type=script&lang=js&"
import style0 from "./CongestionOld.vue?vue&type=style&index=0&id=14836154&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14836154",
  null
  
)

export default component.exports